<template>
  <div class="addProductsComponent">
    <div v-if="loading" class="text-center">
      <v-progress-circular class="mt-auto" :size="70" :width="7" color="primary" indeterminate></v-progress-circular>
    </div>
    <div v-else class="col-md-12">
      <v-form ref="form" lazy-validation class="mt-5 col-sm-12 col-md-12">
        <div class="custom-row">
          <div class="col-sm-12 col-md-4">

            <div v-if="this.roleId !== '1'">
              <v-select color="secondary" label="*Modo" placeholder="Selecciona un modo de categoría" required
                :items=modos item-text="nombre" item-value="idModoCategoria" v-model="formData.idModo"
                @change="actualizarCategorias" :disabled="formData.idModo === 2" :rules="modoRules"></v-select>
            </div>

            <div v-if="this.roleId === '1'">
              <v-select color="secondary" label="*Modo" placeholder="Selecciona un modo de categoría" required
                :items=modos item-text="nombre" item-value="idModoCategoria" v-model="formData.idModo"
                @change="actualizarCategorias" :rules="modoRules"></v-select>
            </div>

            <v-select :disabled=!formData.idModo color="secondary" label="*Categoría" required
              :items="categoriasFiltradas" item-value="idCategoriaComercial" item-text="nombre"
              :value.sync="formData.idCategoriaComercial" v-model="formData.idCategoriaComercial"
              @change="actualizarSubCategorias" :rules="categoriaRules"></v-select>

            <v-select :disabled=!formData.idCategoriaComercial color=secondary label="*Subcategoría" required
              :items="subCategoriasFiltradas" item-text="nombreTipoProducto" item-value="idTipoProducto"
              v-model="formData.idSubCategoria" :rules="subCategoria"></v-select>

            <v-select v-if="formData.idModo === 1" :disabled=!formData.idSubCategoria color=secondary label="*Proveedor"
              required :items="proveedores" item-text="nameSupplier" item-value="supplierId"
              v-model="formData.supplierId" :rules="proveedorRules"></v-select>


            <v-text-field color=secondary label="*Nombre Producto" required v-model="formData.nombre"
              :rules="nombreRules" :counter="40" :maxlength="40"></v-text-field>

            <v-text-field color=secondary label="*Código Producto" required v-model="formData.codProducto"
              :rules="codigoProductoRules" :counter="6" :maxlength="6"></v-text-field>

            <v-text-field color=secondary label="*Descripción" required v-model="formData.descripcion"
              :rules="descripcionRules" :counter="50" :maxlength="50"></v-text-field>

          </div>

          <div class="col-sm-12 col-md-4">

            <v-text-field v-if="formData.idModo === 1" :disabled="!formData.idModo" color="secondary" label="*Precio"
              placeholder="Ingrese el precio" required v-model="formattedPrecio" @keydown="handleKeyDown"
              @blur="handleBlur" type="text" :rules="valorUnitarioClienteRules" clearable></v-text-field>

            <input type="file" class="btn-cargue" @change="handleFileChange" ref="fileInput" style="display: none;"
              accept=".pdf" />
            <v-text-field readonly color=secondary label="*Archivo Detalle" required
              v-model="formData.archivoDetalleNombre" :rules="archivoDetalleRules" @click="triggerFileInput"
              @change="handleFileChange" append-icon="mdi-file-find"></v-text-field>

            <v-text-field v-if="formData.idModo === 1" :disabled="!formData.idModo" color=secondary label="Link youtube"
              :placeholder="placeholderEnlaceInformacionYoutube" v-model="formData.linkYoutube" :counter="200"
              :maxlength="200">
            </v-text-field>

            <v-text-field color=secondary label="*Característica 1" required v-model="formData.caracteristica1"
              :rules="caracteristicaRules" :counter="40" :maxlength="40"></v-text-field>

            <v-text-field color=secondary label="Característica 2" required v-model="formData.caracteristica2"
              :counter="40" :maxlength="40"></v-text-field>

            <v-text-field color=secondary label="Característica 3" required v-model="formData.caracteristica3"
              :counter="40" :maxlength="40"></v-text-field>

            <v-text-field color=secondary label="*Sitio web" :placeholder="placeholderEnlaceInformacion" required
              v-model="formData.enlaceInformacion" :rules="enlaceInformacionRules" :counter="200"
              :maxlength="200"></v-text-field>

            <v-row>
              <v-col cols="4" md="3" sm="3">
                <v-select color="secondary" label="*Indicativo" required :items="listGender"
                  item-text="countryPhoneCode" item-value="countryPhoneCodeId" v-model="formData.countryPhoneCodeId"
                  :rules="CountryPhoneCodeRules">
                </v-select>
              </v-col>
              <v-col cols="8" md="9" sm="9">
                <v-text-field color="secondary" label="*Contacto WhatsApp" placeholder="Ingrese el Contacto WhatsApp"
                  required :rules="[...idNumberCRules, idNumberCLengthRule]" v-model="formData.contacto"
                  @keydown="handleKeyDown" inputmode="numeric" pattern="[0-9]{10}" :counter="10" :maxlength="10">
                </v-text-field>
              </v-col>
            </v-row>
          </div>

        </div>
      </v-form>


    </div>
    <v-tooltip left>
      <template v-slot:activator="{ on, attrs }">
        <v-btn fab fixed bottom right dark large color="primary" v-bind="attrs" v-on="on" @click="submitForm"><v-icon
            dark>mdi-content-save</v-icon>
        </v-btn>
      </template>
      <span>Guardar Producto</span>
    </v-tooltip>
  </div>
</template>

<script>

import EventBus from '@/utils/event_bus.js';
import { mapActions, mapGetters } from "vuex";
import Swal from "sweetalert2";

import {
  PRODUCTS_M,
  ACTION_POST_CREATE_PRODUCTS,
  GET_LIST_COUNTRY,
  ACTION_GET_LIST_COUNTRY,
  GET_STATE_LOADING,
} from "@/views/products/store/types/types.js";

import {
  BOARD_M,
  GET_CATEGORIES,
  ACTION_GET_CATEGORIES,
  GET_SUBCATEGORIES,
  ACTION_GET_SUBCATEGORIES,
  GET_MODO,
  ACTION_GET_MODE,
} from "@/views/categories_board/store/types/types.js";

import {
  MARKETPLACE_M,
  GET_CATEGORIES_MARKETPLACE,
  ACTION_GET_CATEGORIES_MARKETPLACE,
  GET_SUBCATEGORIES_MARKETPLACE,
  ACTION_GET_SUBCATEGORIES_MARKETPLACE
} from "@/views/categories_marketplace/store/types/types.js";

import {
  SUPPLIERS_M,
  GET_SUPPLIERS,
  ACTION_GET_SUPPLIERS,
} from "@/views/suppliers/store/types/types.js"
export default {
  name: "addProductsComponent",
  components: {

  },

  data() {
    return {
      formData: {
        idModo: null,
        idCategoriaComercial: null,
        idSubCategoria: null,
        supplierId: null,
        nombre: null,
        codProducto: null,
        descripcion: null,
        archivoDetalle: null,
        linkYoutube: null,
        valorUnitarioCliente: 0,
        archivoDetalleNombre: null,
        caracteristica1: null,
        caracteristica2: null,
        caracteristica3: null,
        enlaceInformacion: null,
        contacto: '',
        countryPhoneCodeId: 1
      },
      categoriasFiltradas: [],
      subCategoriasFiltradas: [],
      roleId: sessionStorage.getItem("roleId"),
      entersContados: 0,
      modoRules: [
        v => !!v || "El modo de la categoría es requerido"
      ],
      categoriaRules: [
        v => !!v || "La categoría es requerida"
      ],
      subCategoria: [
        v => !!v || "La Subcategoría es requerida"
      ],
      proveedorRules: [
        v => !!v || "El proveedor es requerido"
      ],
      nombreRules: [
        v => !!v || "El nombre es requerido"
      ],
      codigoProductoRules: [
        v => !!v || "El código es requerido",
      ],
      descripcionRules: [
        v => !!v || "La descripción es requerida"
      ],

      valorUnitarioClienteRules: [
        v => !!v || "El precio es requerido"
      ],

      archivoDetalleRules: [
        v => !!v || "Achivo en formato PDF es requerido"
      ],
      caracteristicaRules: [
        v => !!v || "La característica es requerida"
      ],
      enlaceInformacionRules: [
        v => !!v || "El sitio web es requerido"
      ],
      CountryPhoneCodeRules: [
        v => !!v || "El indicativo es requerido"
      ],
      idNumberCRules: [
        v => !!v || "El contacto WhatsApp es requerido",
      ],

      idNumberCLengthRule: v =>
        (v && v.length == 10) || "El contacto WhatsApp debe tener 10 dígitos",

      showErrorMessages: false,
      formattedPrecio: '',

    };

  },

  async mounted() {
    await this.getActionProveedores();
    await this.getActionModos();
    await this.isSuperAdmin();
    this.getActionListCountry();
  },


  computed: {
    ...mapGetters({
      loading: [`${PRODUCTS_M}${GET_STATE_LOADING}`],
      categoriaPizarra: [`${BOARD_M}${GET_CATEGORIES}`],
      categoriaMarketplace: [`${MARKETPLACE_M}${GET_CATEGORIES_MARKETPLACE}`],
      subCategoriaPizarra: [`${BOARD_M}${GET_SUBCATEGORIES}`],
      subCategoriaMarketplace: [`${MARKETPLACE_M}${GET_SUBCATEGORIES_MARKETPLACE}`],
      proveedores: [`${SUPPLIERS_M}${GET_SUPPLIERS}`],
      modos: [`${BOARD_M}${GET_MODO}`],
      listGender: [`${PRODUCTS_M}${GET_LIST_COUNTRY}`],

    }),



    placeholderEnlaceInformacion() {
      // observar el valor de formData.idModo
      if (this.formData.idModo === 2) {
        return "https://dominio.com";
      } else if (this.formData.idModo === 1) {
        return "https://www.dominio.com";
      } else {
        return "";
      }
    },
    placeholderEnlaceInformacionYoutube() {
      // Mirar el valor de formData.idModo
      if (this.formData.idModo === 2) {
        return "https://www.youtube.com/watch?v=";
      } else if (this.formData.idModo === 1) {
        return "https://www.youtube.com/watch?v=";
      } else {
        return "";
      }
    },

  },

  methods: {
    ...mapActions({
      getActionModos: `${BOARD_M}${ACTION_GET_MODE}`,
      getActionCategoriaPizarra: `${BOARD_M}${ACTION_GET_CATEGORIES}`,
      getActionSubCategoriaPizarra: `${BOARD_M}${ACTION_GET_SUBCATEGORIES}`,
      getActionCategoriaMarketplace: `${MARKETPLACE_M}${ACTION_GET_CATEGORIES_MARKETPLACE}`,
      getActionSubCategoriaMarketplace: `${MARKETPLACE_M}${ACTION_GET_SUBCATEGORIES_MARKETPLACE}`,
      getActionProveedores: `${SUPPLIERS_M}${ACTION_GET_SUPPLIERS}`,
      postActionCrearProducto: `${PRODUCTS_M}${ACTION_POST_CREATE_PRODUCTS}`,
      getActionListCountry: `${PRODUCTS_M}${ACTION_GET_LIST_COUNTRY}`,

    }),
    async isSuperAdmin() {
      if (this.roleId !== "1") {
        this.formData.idModo = 2;
        this.categoriasFiltradas = await this.getActionCategoriaPizarra(2);
      }
    },

    handleKeyDown(event) {
      // Permite solo números, la tecla de borrar y el punto para decimales
      if (!/^\d$/.test(event.key) && event.key !== 'Backspace' && event.key !== '.') {
        event.preventDefault();
      }
    },

    handleBlur() {
      // Convierte el valor a número con dos decimales cuando el campo pierde el foco
      if (this.formattedPrecio) {
        const numberValue = parseFloat(this.formattedPrecio.replace(/,/g, '')); // Elimina todas las comas
        if (!isNaN(numberValue)) {
          this.formattedPrecio = this.formatNumber(numberValue); // Formatea el número sin comas
          this.formData.valorUnitarioCliente = numberValue;  // Asigna el valor numérico al modelo
        } else {
          this.formattedPrecio = '';
          this.formData.valorUnitarioCliente = null;
        }
      }
    },

    formatNumber(value) {
      // Formatear el número con dos decimales sin comas de separación de miles
      return parseFloat(value).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },

    async submitForm() {
      try {
        // Validar el formulario antes de enviarlo
        const validationErrors = this.validateForm();
        // Si hay errores de validación, mostrarlos en un único Swal y no enviar el formulario
        if (Object.keys(validationErrors).length > 0) {
          const errorMessages = Object.values(validationErrors).join('<br>');
          Swal.fire({
            icon: 'error',
            title: 'Errores de validación',
            html: '<div class="swal-subtitle"><b>Los siguientes campos son requeridos:</b></div><br>' + errorMessages,
            confirmButtonColor: '#6E17A5'
          });

          return;
        }

        if (this.formData.idModo === 2) {
          this.formData.supplierId = sessionStorage.getItem("idEmpresa")
        }

        if (!this.formData.linkYoutube || !this.formData.linkYoutube.trim()) {
          this.formData.linkYoutube = '';
        }
        const save = await this.postActionCrearProducto(this.formData);
        if (!save) {

          return Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Debes diligenciar los campos'
          })
        }
        await this.clearForm();
        this.formData.valorUnitarioCliente = null;
        this.formattedPrecio = '';
        EventBus.$emit('form-submit-products');

      } catch (error) {
        console.error("Fallo al enviar")
      }
    },

    validateForm() {

      const youtubePattern = /^https?:\/\/(www\.)?youtube\.com/;
      this.showErrorMessages = true;
      const errors = {};

      // Validación de otros campos
      if (!this.formData.idModo) {
        errors.idModo = 'Modo';
      }

      if (!this.formData.idCategoriaComercial) {
        errors.idCategoriaComercial = 'Categoría';
      }

      if (!this.formData.idSubCategoria) {
        errors.idSubCategoria = 'Subcategoría';
      }

      if (!this.formData.supplierId && this.formData.idModo === 1) {
        errors.supplierId = 'Proveedor';
      }

      if (!this.formData.nombre || !this.formData.nombre.trim()) {
        errors.nombre = 'Nombre producto';
      }

      if (!this.formData.codProducto || !this.formData.codProducto.trim()) {
        errors.codProducto = 'Código producto';
      }

      if (!this.formData.descripcion || !this.formData.descripcion.trim()) {
        errors.descripcion = 'Descripción';
      }

      if (!this.formattedPrecio) {
        if (this.formData.idModo === 1) {
          errors.valorUnitarioCliente = 'Precio'
        }
      }

      if (!this.formData.archivoDetalle) {
        errors.archivoDetalle = 'Archivo Detalle';
      }

      if (!this.formData.caracteristica1 || !this.formData.caracteristica1.trim()) {
        errors.caracteristica1 = 'Característica 1';
      }

      if (this.formData.caracteristica2 && !/\S/.test(this.formData.caracteristica2)) {
        errors.caracteristica2 = 'Característica 2 no debe contener solo espacios en blanco';
      }

      if (this.formData.caracteristica3 && !/\S/.test(this.formData.caracteristica3)) {
        errors.caracteristica3 = 'Característica 3 no debe contener solo espacios en blanco';
      }

      if (!this.formData.enlaceInformacion || !this.formData.enlaceInformacion.trim()) {
        errors.enlaceInformacion = 'Sitio web';
      }

      if (!this.formData.contacto || !this.formData.contacto.trim() || this.formData.contacto.length !== 10) {
        errors.contacto = 'Contacto WhatsApp';
      }
      if (this.formData.linkYoutube && !youtubePattern.test(this.formData.linkYoutube)) {
        errors.linkYoutube = 'Link youtube';
      }
      return errors;
    },

    contarEnters() {
      // Contar los enters en el valor actual del textarea
      const enters = this.formData.contacto.split("\n").length - 1;

      // Limitar a 3 enters
      if (enters > 2) {
        this.formData.contacto = this.formData.contacto.replace(/\n/g, ',');
      } else {
        this.entersContados = enters;
      }
    },

    async actualizarCategorias() {
      if (this.formData.idModo === 1) {
        // Si es Marketplace, obtén las categorías de Marketplace
        this.categoriasFiltradas = await this.getActionCategoriaMarketplace(1);
      } else if (this.formData.idModo === 2) {
        // Si es Pizarra, obtén las categorías de Pizarra
        this.categoriasFiltradas = await this.getActionCategoriaPizarra(2);
      } else {
        // En caso contrario, limpia la lista de categorías
        this.categoriasFiltradas = [];
      }
    },

    async actualizarSubCategorias() {
      if (this.formData.idCategoriaComercial) {
        if (this.formData.idModo === 1) {
          // Si es Pizarra, obtén las subcategorías de Pizarra
          const subCategoriasFiltradasP = await this.getActionSubCategoriaPizarra(this.formData.idCategoriaComercial);
          this.subCategoriasFiltradas = subCategoriasFiltradasP.tipoProductos;
          this.formData.idSubCategoria = null;
        } else if (this.formData.idModo === 2) {
          // Si es Marketplace, obtén las subcategorías de Marketplace
          const subCategoriasFiltradasM = await this.getActionSubCategoriaMarketplace(this.formData.idCategoriaComercial);
          this.subCategoriasFiltradas = subCategoriasFiltradasM.tipoProductos;
          this.formData.idSubCategoria = null;
        }
      } else {
        // En caso contrario, limpia la lista de subcategorías
        this.subCategoriasFiltradas = [];
      }

    },

    handleFileChange(event) {
      const file = event.target.files[0];

      // Verifica si el arhivo es un PDF
      if (file.type === 'application/pdf') {
        // Verifica el tamaño del archivo (en bytes)
        const fileSizeMB = file.size / (1024 * 1024); // Convertir a megabytes
        const maxFileSizeMB = 30; // Tamaño máximo permitido en megabytes

        if (fileSizeMB > maxFileSizeMB) {
          // Muestra un mensaje de error si el archivo excede el tamaño máximo permitido
          Swal.fire({
            icon: 'error',
            title: 'Error de validación',
            text: `El tamaño del archivo debe ser menor o igual a ${maxFileSizeMB} MB.`,
          });

          // Reinicia el campo de archivo
          this.formData.archivoDetalleNombre = '';
          this.formData.archivoDetalle = null;
        } else {
          // Asigna el nombre y el archivo al modelo si cumple con los requisitos
          this.formData.archivoDetalleNombre = file.name;
          this.formData.archivoDetalle = file;
        }
      } else {
        // Muestra un mensaje de error si el archivo no es un PDF
        Swal.fire({
          icon: 'error',
          title: 'Error de validación',
          text: 'Por favor, selecciona un archivo en formato PDF.',
        });

        // Reinicia el campo de archivo
        this.formData.archivoDetalleNombre = '';
        this.formData.archivoDetalle = null;
      }
    },

    triggerFileInput() {
      this.$refs.fileInput.click();
    },

    clearForm() {
      this.formData.idModo = null;
      this.formData.idCategoriaComercial = null;
      this.formData.idSubCategoria = null;
      this.formData.supplierId = null,
        this.formData.nombre = null;
      this.formData.codProducto = null;
      this.formData.descripcion = null;
      this.formData.valorUnitarioCliente = null;
      this.formData.archivoDetalle = null,
        this.formData.linkYoutube = null,
        this.formData.archivoDetalleNombre = null;
      this.formData.caracteristica1 = null;
      this.formData.caracteristica2 = null;
      this.formData.caracteristica3 = null;
      this.formData.enlaceInformacion = null;
      this.formData.contacto = null;
      this.formData.countryPhoneCodeId = null;
    },
  },

};
</script>

<style lang="css" scoped>
.addProductsComponent {
  display: flex;
  gap: 40px;
  flex-direction: row;
  justify-content: center;
}

.custom-row {
  display: flex;
  gap: 40px;
  flex-direction: row;
  justify-content: center;
}

.v-textarea-custom {
  max-height: 3em;
  /* Establece la altura máxima en 3 líneas */
  resize: none;
  /* Evita que el usuario pueda redimensionar el textarea */
}

/*Resposive*/

@media screen and (max-width: 960px) {
  .row-uno {
    flex-direction: column-reverse;
  }
}

@media screen and (max-width: 912px) {
  .col-md-12 {
    gap: 40px;
  }
}

@media screen and (max-width: 820px) {
  .col-md-12 {
    gap: 40px;
  }

  .custom-row {
    display: flex;
    gap: 20px;
    flex-direction: column;
    justify-content: center;
  }
}

@media screen and (max-width: 768px) {
  .col-md-12 {
    gap: 40px;
  }

  .custom-row {
    display: flex;
    gap: 20px;
    flex-direction: column;
    justify-content: center;
  }
}

@media screen and (max-width: 425px) {
  .col-md-12 {
    gap: 10px;
    display: flex;
    flex-direction: column-reverse;
  }

  .custom-row {
    display: flex;
    gap: 50px;
    flex-direction: column;
    justify-content: center;
  }
}
</style>